import { Box, Typography } from "@mui/material"

import heart_warning from "static/images/statuses/heart_warning.png"
import useTranslation from "hooks/use_translation"

import StatusCard from "./Diseases"

const Warning = ({ diseases }) => {
  const { pages } = useTranslation()

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", color: "white" }}>
      <Box
        component="img"
        alt="Image"
        src={heart_warning}
        sx={{ maxHeight: 200, maxWidth: 250, mt: 7, alignSelf: "center", mb: -4 }}
      />
      <Typography variant="h5" sx={{ textAlign: "center", fontWeight: 700, mb: 4 }}>
        {pages?.client_main?.warning_title}
      </Typography>
      <StatusCard data={diseases} />
    </Box>
  )
}

export default Warning
